import { Box, Grid, Typography } from '@mui/material';
import { emptyValue } from '../../../../settings/appConfig';
import { billinglabelTitle, detailsValue } from '../../../../assets/styles/appStyles';
import * as Styles from '../../../../assets/styles/appStyles';
import { gridContainer, infoGridItem } from '../../Styles/CustodianAddressDetailsStyles';

export default function BillingInfoPayeeDetails({
  payeeName,
  payeeCity,
  payeeAddress,
  payeeContact,
  payeePostCode,
  payeeStateName,
}: {
  payeeName: string;
  payeeCity: string;
  payeeAddress: string;
  payeeContact: string;
  payeePostCode: string;
  payeeStateName: string;
}) {
  return (
    <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
      <Grid container item rowSpacing={3}>
        <Grid item xs={12} sx={infoGridItem}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography sx={billinglabelTitle}>Payee name</Typography>
              <Box sx={Styles.labelText}>{!!payeeName ? payeeName : emptyValue}</Box>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={billinglabelTitle}>Payee city</Typography>
              <Box sx={Styles.labelText}>{!!payeeCity ? payeeCity : emptyValue}</Box>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={billinglabelTitle}>Payee address</Typography>
              <Box sx={Styles.labelText}>
                {!!payeeAddress ? payeeAddress : emptyValue}
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={billinglabelTitle}>Payee phone</Typography>
              <Box sx={Styles.labelText}>
                {!!payeeContact ? payeeContact : emptyValue}
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={billinglabelTitle}>Payee state</Typography>
              <Box sx={Styles.labelText}>
                {!!payeeStateName ? payeeStateName : emptyValue}
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={billinglabelTitle}>Payee Zip/Postal Code</Typography>
              <Box sx={Styles.labelText}>
                {!!payeePostCode ? payeePostCode : emptyValue}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
